import { useState } from "react";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import { registerReservation } from "../../../api/reservation";
import TournamentList from "./tournamentList";
import { TournamentResponse } from "../../../api/tournament";

import ImageDropzone from "../../../component/ImageDropZone";
import { PageContentHeaderButton } from "../../../styles/page";
import {
  DataWrapper,
  DataRow,
  ImageDropWrapper,
  ImageDropInitialContent,
  InputDataWrapper,
  Label,
  ReservationCreateActions,
  ReservationCreatePopupContentBodyWrapper,
  ReservationCreatePopupContentHeaderWrapper,
  ReservationCreatePopupContentWrapper,
  ReservationCreatePopupContainer,
  Value,
  DataRowWrapper,
} from "../styles/createReservationPopup";

const CreateReservationPopup = (props: {
  setIsCreateOpen: any;
  getList: any;
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [tournament, setTournament] = useState<TournamentResponse | null>(null);
  const pub = useRecoilValue(pubState);
  const setIsCreateOpen = props.setIsCreateOpen;
  const getList = props.getList;
  const create = async () => {
    if (!tournament) {
      alert("토너먼트를 선택해주세요.");
      return;
    }
    if (!file) {
      alert("포스터 이미지를 선택해주세요. ");
      return;
    }

    if (pub && file) {
      const formData = new FormData();
      formData.append("cafeId", pub.id.toString());
      formData.append("tournamentId", tournament?.id.toString());
      formData.append("title", tournament?.title);
      formData.append("description", tournament?.title);
      formData.append("isSeedPay", "false");
      formData.append("limitTime", "2024-10-10 14:00:00");
      formData.append("file", file);

      try {
        await registerReservation(formData);
        setIsCreateOpen(false);
        getList();
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleImageUpload = (file: File) => {
    setFile(file);
  };
  return (
    <ReservationCreatePopupContainer>
      <ReservationCreatePopupContentWrapper>
        <ReservationCreatePopupContentHeaderWrapper>
          <span>예약 세팅</span>
          <img
            src="/image-web/tournament/close.svg"
            onClick={() => {
              setIsCreateOpen(false);
            }}
            alt="close"
          />
        </ReservationCreatePopupContentHeaderWrapper>
        <ReservationCreatePopupContentBodyWrapper>
          <ImageDropWrapper>
            <ImageDropzone onImageUpload={handleImageUpload}>
              <ImageDropInitialContent>
                <img src="/image-web/icon/image.svg" alt="Initial content" />
                <h2>포스터 이미지를 올려주세요!</h2>
                <p>최소 400px * 400px,</p>
                <p>최대 1600px * 1600px로 설정할 수 있습니다.</p>
              </ImageDropInitialContent>
            </ImageDropzone>
          </ImageDropWrapper>
          <InputDataWrapper>
            <DataWrapper>
              <DataRowWrapper>
                <DataRow>
                  <Label>매장 이름</Label>
                  <Value>{pub?.cafeName}</Value>
                </DataRow>
                <DataRow>
                  <Label>주소</Label>
                  <Value>{`${pub?.newAddress} ${pub?.detailAddress}`}</Value>
                </DataRow>
                <DataRow>
                  <Label>매장 전화번호</Label>
                  <Value>{pub?.vcn}</Value>
                </DataRow>
                <DataRow>
                  <Label>토너먼트</Label>
                  <Value>{tournament?.title}</Value>
                </DataRow>
              </DataRowWrapper>
              <TournamentList
                tournament={tournament}
                setTournament={setTournament}
              />
            </DataWrapper>
            <ReservationCreateActions>
              <PageContentHeaderButton
                $weight={1}
                $variant={"default"}
                onClick={() => create()}
              >
                초기화
              </PageContentHeaderButton>
              <PageContentHeaderButton
                $weight={3}
                $variant={"positive"}
                onClick={() => create()}
              >
                예약 세팅하기
              </PageContentHeaderButton>
            </ReservationCreateActions>
          </InputDataWrapper>
        </ReservationCreatePopupContentBodyWrapper>
      </ReservationCreatePopupContentWrapper>
    </ReservationCreatePopupContainer>
  );
};
export default CreateReservationPopup;
